import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';

export const selectFraudDetectorSimulatorOptions = createSelector(
  fromFeature.getFraudDetectorSimulatorState,
  (state) => state.options,
);
export const selectFraudDetectorSimulatorLevel = createSelector(
  fromFeature.getFraudDetectorSimulatorState,
  (state) => state.level,
);
